import buildThemeFromCore from '../../theme/buildThemeFromCore';
import {SET_THEME} from '../actions/action-types';

const themeReducer = (state = buildThemeFromCore(), action) => {
  if (action.type === SET_THEME) {
    return action.theme;
  }
  return state;
};

export default themeReducer;
